namespace $.$$ {
	$mol_style_define($bog_blitz_admin_quiz, {
		background: {
			color: $mol_theme.card,
		},
		border: {
			radius: '0.5rem',
		},
		padding: {
			top: '0.25rem',
			bottom: '0.25rem',
			left: '0.75rem',
			right: '0.25rem',
		},
		align: {
			items: 'center',
		},
		gap: '0.25rem',
		Title_input: {
			flex: {
				grow: 1,
				shrink: 1,
			},
		},
		Shared_badge: {
			color: $mol_theme.focus,
		},
		Delete: {
			color: '#cc3333',
		},
	})
}
